import React from 'react';
import Skeleton from '../../common/skeleton';
import { Row, Col, Card } from 'react-bootstrap';

const SendDocumentSkeleton = () => (
  <>
    <Card className="skeleton-card">
      <Row className="mt-4">
        <Col className="form-group">
          <Skeleton count={1} width={100} className={'form-label'} />
          <Skeleton
            count={1}
            height={31}
            containerClassName={'form-control p-0 line-height-none'}
          />
        </Col>
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={31}
            containerClassName={'form-control p-0 line-height-none'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={32}
            containerClassName={'form-control p-0 line-height-none'}
          />
        </Col>
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton
            count={1}
            height={32}
            containerClassName={'form-control p-0 line-height-none'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton count={1} height={80} className={'comments-skeleton'} />
        </Col>
      </Row>

      <Row className="mt-3 mb-4">
        <Col className="form-group">
          <Skeleton count={1} width={100} containerClassName={'form-label'} />
          <Skeleton count={1} height={80} className={'comments-skeleton'} />
        </Col>
      </Row>
    </Card>
  </>
);

export default SendDocumentSkeleton;
